module.exports = __webpack_public_path__ + "media/img/private-venue/hover-cheers-9f08e654a7496f6922f4cdacf83aaf4a.svg";